import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import EmptyListState from '../components/EmptyListState'
import Footer from '../components/Footer'
import PageWrapper from '../components/PageWrapper'
import PresetTourCard from '../components/presets/PresetTourCard'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'
import { fetchFirestoreList } from '../utils/fetchFirestoreList'

export default function Tours() {
  const [tours, setTours] = useState([])
  const [loadError, setLoadError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    ;(async () => {
      setLoading(true)
      const { items, error } = await fetchFirestoreList('Tours')
      if (!active) return
      setTours(items)
      setLoadError(error)
      setLoading(false)
    })()
    return () => {
      active = false
    }
  }, [])

  return (
    <motion.div
      initial={{ y: -150, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <PageSeo h1="Jamaica Tours" />
      <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
      <PageWrapper
        name={'Tours'}
        display={
          <h1 className="txt-big">
            <strong>
              <span className="text-success">J</span>
              <span className="text-warning">a</span>
              <span className="text-danger">m</span>
              <span className="text-success">a</span>
              <span className="text-warning">i</span>
              <span className="text-danger">c</span>
              <span className="text-success">a</span>
              <span className="text-warning"> </span>
              <span className="text-danger">T</span>
              <span className="text-success">o</span>
              <span className="text-warning">u</span>
              <span className="text-danger">r</span>
              <span className="text-success">s</span>
            </strong>
          </h1>
        }
      >
        <span className="txt-cream txt-shadow">
          Scheduled island tours plus custom routes serving Montego Bay, Ocho Rios, and Negril from Discovery Bay.
        </span>
      </PageWrapper>

      <Container style={{ marginBottom: '20vh' }}>
        <Row className="mb-4">
          <Col className="text-center">
            <Link className="btn btn-lg bt-cream hero-cta-btn" to="/tours/book">
              Book a custom tour
            </Link>
            <p className="small text-cream mt-2">Sign in required when you book.</p>
          </Col>
        </Row>
        {loading ? (
          <p className="text-center text-cream" role="status">Loading tours…</p>
        ) : loadError ? (
          <EmptyListState
            title="Tours unavailable right now"
            message="We could not load tour listings. Please try again shortly."
            permissionHint="If this persists, Firestore security rules may need to be deployed for public read access."
            actionLabel="Contact via About Us"
            actionTo="/about-us"
          />
        ) : tours.length === 0 ? (
          <EmptyListState
            title="No tours listed yet"
            message="Check back soon for scheduled departures, or request a custom tour."
            actionLabel="Book a custom tour"
            actionTo="/tours/book"
          />
        ) : (
          <Row>
            {tours.map((tour) => (
              <Col key={tour.id} className="col-lg-4 col-md-6 col-sm-12 mb-3">
                <PresetTourCard tour={tour} />
              </Col>
            ))}
          </Row>
        )}
      </Container>

      <Footer />
    </motion.div>
  )
}
